export const INFO_BAR_CONFIG = {
  COOKIES_ACCEPTANCE: {
    key: 'cookiesacceptance',
    value: { true: 'true', false: 'false' }
  }
};
